import { Icon, InputGroup, Intent, TextArea } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Clearfix from 'components/elements/clearfix';
import IconRequired from 'components/elements/required-icon';
import YearSelect from 'components/elements/select-year';
import { COLOR } from 'config';
import { get, isEmpty } from 'lodash';
import { createForm } from 'rc-form';
import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

const FIELDS = {
  ProjectName: 'ProjectName',
  NumberDoc: 'NumberDoc',
  ReportYear: 'ReportYear',
  Agency: 'Agency',
  Admisnistor: 'Admisnistor',
  ConsultingAgency: 'ConsultingAgency',
  ResultsManagementAgency: 'ResultsManagementAgency',
  ProjectObjectives: 'ProjectObjectives',
  Notes: 'Notes',
};

const LABELS = {
  ProjectName: 'Tên dự án',
  NumberDoc: 'Số văn bản (quyết định/ báo cáo)',
  ReportYear: 'Năm báo cáo',
  Agency: 'Cơ quan chủ quản',
  Admisnistor: 'Cơ quan chủ trì',
  ConsultingAgency: 'Cơ quan tư vấn',
  ResultsManagementAgency: 'Cơ quan phê duyệt',
  ProjectObjectives: 'Mục tiêu dự án',
  Notes: 'Ghi chú',
};

const FormItem = (props) => {
  const { form, name, label, children, required } = props;
  const {getFieldError} = form || {};
  return (
    <div>
      <Row>
        <Col xs={4}>
          <LabelContainer>
            {label}
            {required ? <IconRequired /> : null}
          </LabelContainer>
        </Col>
        <Col xs={4}>
          {children}

          <ErrorContainer>
            {typeof getFieldError === 'function'
              ? (getFieldError(name) || []).join(', ')
              : null}
          </ErrorContainer>
        </Col>
      </Row>
      <Clearfix height={16} />
    </div>
  );
};

const BiodiversityForm = (props) => {
  const { form, biodiversity, handleSubmit } = props;
  const { getFieldProps } = form;

  useEffect(() => {
    if(isEmpty(biodiversity)) return
    form.setFieldsValue({
      ProjectName: get(biodiversity, 'ProjectName'),
      NumberDoc: get(biodiversity, 'NumberDoc'),
      ReportYear: {
        value: get(biodiversity, 'ReportYear'),
        label: get(biodiversity, 'ReportYear'),
      },
      Agency: get(biodiversity, 'Agency'),
      Admisnistor: get(biodiversity, 'Admisnistor'),
      ConsultingAgency: get(biodiversity, 'ConsultingAgency'),
      ResultsManagementAgency: get(biodiversity, 'ResultsManagementAgency'),
      ProjectObjectives: get(biodiversity, 'ProjectObjectives'),
      Notes: get(biodiversity, 'Notes'),
    });
  }, [biodiversity]);

  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!values) return
      const params = {
        ProjectName: get(values, 'ProjectName', '').trim(),
        NumberDoc: get(values, 'NumberDoc', '').trim(),
        ReportYear: get(values, 'ReportYear.value'),
        Agency: get(values, 'Agency'),
        Admisnistor: get(values, 'Admisnistor'),
        ConsultingAgency: get(values, 'ConsultingAgency'),
        ResultsManagementAgency: get(values, 'ResultsManagementAgency'),
        ProjectObjectives: get(values, 'ProjectObjectives'),
        Notes: get(values, 'Notes'),
      };
      handleSubmit(params);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <Row>
        <Col xs={4}>
          <HeaderContainer>
            <Icon
              icon={IconNames.SAVED}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.PRIMARY}
              onClick={onSubmit}
              style={{color: COLOR.SUCCESS}}
            />
            <Clearfix width={8} />
            <Icon
              onClick={() => window.history.back()}
              icon={IconNames.DISABLE}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.DANGER}
            />
          </HeaderContainer>
        </Col>
      </Row>
      <FormItem
        required
        label={LABELS.ProjectName}
        form={form}
        name={FIELDS.ProjectName}
      >
        <InputGroup
          placeholder={LABELS.ProjectName}
          {...getFieldProps(FIELDS.ProjectName, {
            rules: [
              {
                validator: (rule, val, callback) => {
                  if (!(val || '').trim())
                    callback(new Error('Bắt buộc nhập tên dự án'));
                  callback();
                },
              },
            ],
          })}
        />
      </FormItem>
      <FormItem
        required
        label={LABELS.NumberDoc}
        form={form}
        name={FIELDS.NumberDoc}
      >
        <InputGroup
          placeholder='Số văn bản'
          {...getFieldProps(FIELDS.NumberDoc, {
            rules: [
              {
                validator: (rule, val, callback) => {
                  if (!(val || '').trim())
                    callback(new Error('Bắt buộc nhập tên số văn bản'));
                  callback();
                },
              },
            ],
          })}
        />
      </FormItem>
      <FormItem
        required
        name={FIELDS.ReportYear}
        form={form}
        label={LABELS.ReportYear}
      >
        <YearSelect
          hideLabel
          fieldForm={{
            form,
            name: FIELDS.ReportYear,
            option: {
              rules: [
                {
                  validator: (rule, val, callback) => {
                    if (!get(val, 'value'))
                      callback(new Error('Bắt buộc nhập năm báo cáo'));
                    callback();
                  },
                },
              ],
            },
          }}
        />
      </FormItem>
      <FormItem label={LABELS.Agency} form={form} name={FIELDS.Agency}>
        <InputGroup
          placeholder={LABELS.Agency}
          {...getFieldProps(FIELDS.Agency)}
        />
      </FormItem>
      <FormItem
        label={LABELS.ResultsManagementAgency}
        form={form}
        name={FIELDS.ResultsManagementAgency}
      >
        <InputGroup
          placeholder={LABELS.ResultsManagementAgency}
          {...getFieldProps(FIELDS.ResultsManagementAgency)}
        />
      </FormItem>
      <FormItem
        label={LABELS.Admisnistor}
        form={form}
        name={FIELDS.Admisnistor}
      >
        <InputGroup
          placeholder={LABELS.Admisnistor}
          {...getFieldProps(FIELDS.Admisnistor)}
        />
      </FormItem>
      <FormItem
        label={LABELS.ConsultingAgency}
        form={form}
        name={FIELDS.ConsultingAgency}
      >
        <InputGroup
          placeholder={LABELS.ConsultingAgency}
          {...getFieldProps(FIELDS.ConsultingAgency)}
        />
      </FormItem>
      <FormItem
        label={LABELS.ProjectObjectives}
        form={form}
        name={FIELDS.ProjectObjectives}
      >
        <InputGroup
          placeholder={LABELS.ProjectObjectives}
          {...getFieldProps(FIELDS.ProjectObjectives)}
        />
      </FormItem>
      <FormItem label={LABELS.Notes} form={form} name={FIELDS.Notes}>
        <TextArea
          fill
          placeholder={LABELS.Notes}
          {...getFieldProps(FIELDS.Notes)}
        />
      </FormItem>
    </div>
  );
};

export default createForm()(BiodiversityForm);

BiodiversityForm.propTypes = {};

BiodiversityForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityForm/index.js